/*
 *
 * ProcessingRulesPopup
 *
 * @version 1.0.0
 * @author Alessandro Mosca
 * @since 23-Jan-2025
 */

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ProcessingRulesPopup from './ProcessingRulesPopup'
import * as actionLayer from 'Route/TerminalsManagement/modules/TerminalsManagementActions'
import { doPopup } from 'Store/actions/popup'
import * as formikActions from 'Store/actions/formik'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(dispatch),
  doCreateProcessingRules: () => dispatch(actionLayer.doCreateProcessingRules()),
  closeCreateProcessingRulesPopup: () => dispatch(doPopup('')),
  closeProcessingRulesPopup: () => dispatch(doPopup('')),
  submitForm: (values) => {
    dispatch(formikActions.doSaveForm(values))
  }
})

const mapStateToProps = (state) => ({
  action: state.popup.popupData,
  isLoading: state?.loading?.local_createUpdateRule || false
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(ProcessingRulesPopup)
